import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/shared/Layout';
import Login from './components/auth/Login';
import ChangePassword from './components/auth/ChangePassword';
import StudentPage from './pages/StudentPage';
import TeacherPage from './pages/TeacherPage';
import AdminPage from './pages/AdminPage';
import TutorPage from './pages/TutorPage';
import CompanyFormPage from './pages/public/CompanyFormPage';
import TutorAccessPage from './pages/TutorAccessPage';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;

  // Forcer le changement de mot de passe si temp
  if (user.tempPassword && window.location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  switch (user.role) {
    case 'student': return <Navigate to="/student" replace />;
    case 'teacher': return <Navigate to="/teacher" replace />;
    case 'admin': return <Navigate to="/admin" replace />;
    case 'personnel': return <Navigate to="/admin" replace />;
    case 'tutor': return <Navigate to="/tutor" replace />;
    default: return <Navigate to="/login" replace />;
  }
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/entreprise/:token" element={<CompanyFormPage />} />
          <Route path="/tutor/access/:token" element={<TutorAccessPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={
            <PrivateRoute>
              <Layout><ChangePassword /></Layout>
            </PrivateRoute>
          } />
          <Route path="/" element={<PrivateRoute><HomeRedirect /></PrivateRoute>} />
          <Route path="/student/*" element={
            <PrivateRoute roles={['student']}>
              <Layout><StudentPage /></Layout>
            </PrivateRoute>
          } />
          <Route path="/teacher/*" element={
            <PrivateRoute roles={['teacher']}>
              <Layout><TeacherPage /></Layout>
            </PrivateRoute>
          } />
          <Route path="/admin/*" element={
            <PrivateRoute roles={['admin', 'personnel']}>
              <Layout><AdminPage /></Layout>
            </PrivateRoute>
          } />
          <Route path="/tutor/*" element={
            <PrivateRoute roles={['tutor']}>
              <Layout><TutorPage /></Layout>
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
